// Who runs TrueChops and how to reach them, used by the legal pages and the age gate.
// Before relying on these pages: set the NEXT_PUBLIC_LEGAL_* and NEXT_PUBLIC_DMCA_* values, register
// the designated agent at https://dmca.copyright.gov (the details must match), and have counsel
// review the policy text. Bump TERMS_VERSION when the Terms change; uploads record which version
// the uploader agreed to.
export const LEGAL = {
  operator: process.env.NEXT_PUBLIC_LEGAL_OPERATOR || "TrueChops",
  site: "truechops.com",
  contactEmail: process.env.NEXT_PUBLIC_LEGAL_CONTACT_EMAIL || "support@truechops.com",
  privacyEmail: process.env.NEXT_PUBLIC_LEGAL_PRIVACY_EMAIL || "privacy@truechops.com",
  // The designated agent for copyright notices (17 U.S.C. § 512(c)(2)).
  agent: {
    name: process.env.NEXT_PUBLIC_DMCA_AGENT_NAME || "Copyright Agent, TrueChops",
    email: process.env.NEXT_PUBLIC_DMCA_AGENT_EMAIL || "copyright@truechops.com",
    address: process.env.NEXT_PUBLIC_DMCA_AGENT_ADDRESS || "",
    phone: process.env.NEXT_PUBLIC_DMCA_AGENT_PHONE || "",
  },
  // e.g. "the State of Texas, United States"; the clause is left out until it's set.
  governingLaw: process.env.NEXT_PUBLIC_LEGAL_GOVERNING_LAW || "",
  updated: "October 30, 2026",
};
export const TERMS_VERSION = "2026-10-30";
// People must be at least this old to create an account (COPPA).
export const MINIMUM_AGE = 13;
// Upheld copyright notices ("strikes") at which an account is closed for repeat infringement.
export const STRIKE_LIMIT = 3;
// A counter-noticed recording comes back after this many business days unless the claimant
// tells us they've filed a court action (17 U.S.C. § 512(g)(2)(C): 10 to 14 business days).
export const COUNTER_NOTICE_BUSINESS_DAYS = 10;
// What people can report a rhythm or its recording for.
export const REPORT_REASONS = {
  copyright: "Copyright infringement", sexual: "Sexual or adult content", violence: "Violence or dangerous acts",
  hate: "Hate speech", harassment: "Harassment or bullying", privacy: "Shares someone’s private information or likeness without consent",
  spam: "Spam or misleading", other: "Something else",
};

// The date `businessDays` weekdays after `from`.
export function addBusinessDays(from, businessDays) {
  const date = new Date(from);
  let left = businessDays;
  while (left > 0) {
    date.setUTCDate(date.getUTCDate() + 1);
    if (![0, 6].includes(date.getUTCDay())) left -= 1;
  }
  return date;
}
